<template>
  <div>
    <v-toolbar flat color="white" class= "pt-3">
      <h2 class="dark-grey--text px-2">Node: {{locationNodeInfo.name}}</h2>
    </v-toolbar>

    <v-toolbar flat color="white">
      <v-tabs  div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}}</v-tab>
      </v-tabs>
    </v-toolbar>

    <div v-if="displayContents('networks')">
      <locationnetworks
        :locationnetworks="locationNetworks"
        @locationNetworkSaved="fetchLocationNetworks()"
      ></locationnetworks>
    </div>
    <div v-if="displayContents('recurringTransactions')">
      <v-toolbar flat color="white">
      <v-btn round color="primary" @click="addRecurringItem()">Add Recurring Transaction</v-btn>
      
    </v-toolbar>
    <v-divider></v-divider>
    <v-data-table
      disable-initial-sort
      :headers="headers"
      :items="recurringTransactions"
      item-key="name"
      :rows-per-page-items="[10, 25, 50, 100]"
    >
      <template v-slot:items="props">
        <td class="justify-center layout px-0">
          <v-icon small @click="editRecurringItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteRecurringItem(props.item)">delete</v-icon>
        </td>
        <td class="text-xs-center">{{props.item.description}}</td>
        <td class="text-xs-center">{{props.item.xeroCode}}</td>
        <td
          class="text-xs-center"
          v-if="props.item.transactionType==='Loan'"
        >{{props.item.transactionType}}: {{props.item.loanAccountCustomer.name}}</td>
        <td class="text-xs-center" v-else>{{props.item.transactionType}}</td>
        <td class="text-xs-center" v-if="props.item.customerOrganisationId!==null">{{props.item.customerOrganisation.name}}</td>
        <td class="text-xs-center" v-else-if="props.item.supplierOrganisationId!==null">{{props.item.supplierOrganisation.name}}</td>
        <td class="text-xs-center" v-else></td>
        <td
          class="text-xs-center red--text"
          v-if="props.item.transactionType!=='Sales'&&props.item.transactionType!=='Loan'"
        >{{props.item.amount | currency}}</td>
        <td
          class="text-xs-center green--text"
          v-else-if="props.item.transactionType==='Sales'||props.item.transactionType==='Loan'"
        >{{props.item.amount | currency}}</td>
      </template>
    </v-data-table>
    </div>
    <div v-if="displayContents('transactions')">
      <transactions
        :locationid="null"
        :switchingcentreid="locationNodeInfo.switchingCentreId"
        :locationnodeid="this.$route.params.locationNodeId"
        :locationnetworkid="null"
        :transactions="nodeTransactions"
        :partners="Partners"
        :descriptionlist="descriptionList"
        :salesvalue="salesValue"
        :cosvalue="cosValue"
        :expensevalue="expenseValue"
        :loanvalue="loanValue"
        @refreshTotals="sum()"
        @transactionAdded="getTransactions()"
      ></transactions>
    </div>
    <div v-if="displayContents('documents')">
      <documentcomponent :locationnodeid="this.$route.params.locationNodeId" :documents="locationNodeDocuments" @documentChange="fetchDocuments"></documentcomponent>
    </div>

     <v-dialog persistent v-model="addTransactionModal" max-width="950px">
      <v-card flat color="white">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">ADD RECURRING TRANSACTION</h1>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
               <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Type"
                  :items="transactionTypes"
                  v-model="recurringTransactionItem.transactionType"
               >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Loan'">
               <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Select Contributor"
                  :items="partners"
                  item-text="name"
                  item-value="id"
                  v-model="recurringTransactionItem.loanAccountCustomerId"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Sales'">
               <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="salesTransactionCategories"
                  v-model="recurringTransactionItem.description"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Cost of Sales'">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="cosTransactionCategories"
                  v-model="recurringTransactionItem.description"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Expense'">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="expenseTransactionCategories"
                  v-model="recurringTransactionItem.description"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Loan'">
               <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="loanTransactionCategories"
                  v-model="recurringTransactionItem.description"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field v-model="recurringTransactionItem.xeroCode" label="Xero Code"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Sales'">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Customer"
                  item-text="name"
                  item-value="id"
                  :items="customers"
                  v-model="recurringTransactionItem.customerOrganisationId"
               >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-else-if="recurringTransactionItem.transactionType===('Cost of Sales'||'Expense')">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Supplier"
                  item-text="name"
                  item-value="id"
                  :items="customers"
                  v-model="recurringTransactionItem.supplierOrganisationId"
               >
               </v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field v-model="recurringTransactionItem.amount" label="*Amount"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-center layout px-0">
          <v-btn color="primary" round @click="addTransactionModal=false, recurringTransactionItem={}">Cancel</v-btn>
          <v-btn color="primary" round @click="saveNewRecurringTransaction">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="editTransactionModal" max-width="950px">
      <v-card flat color="white">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">EDIT RECURRING TRANSACTION</h1>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Type"
                  :items="transactionTypes"
                  v-model="recurringTransactionItem.transactionType"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Loan'">
               <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Select Contributor"
                  :items="partners"
                  item-text="name"
                  item-value="id"
                  v-model="recurringTransactionItem.loanAccountCustomerId"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Sales'">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="salesTransactionCategories"
                  v-model="recurringTransactionItem.description"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Cost of Sales'">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="cosTransactionCategories"
                  v-model="recurringTransactionItem.description"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Expense'">
               <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="expenseTransactionCategories"
                  v-model="recurringTransactionItem.description"
                >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Loan'">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Transaction Category"
                  :items="loanTransactionCategories"
                  v-model="recurringTransactionItem.description"
               >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field v-model="recurringTransactionItem.xeroCode" label="Xero Code"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="recurringTransactionItem.transactionType==='Sales'">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Customer"
                  item-text="name"
                  item-value="id"
                  :items="customers"
                  v-model="recurringTransactionItem.customerOrganisationId"
               >
               </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-else-if="recurringTransactionItem.transactionType===('Cost of Sales'||'Expense')">
                <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Supplier"
                  item-text="name"
                  item-value="id"
                  :items="customers"
                  v-model="recurringTransactionItem.supplierOrganisationId"
               >
               </v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field v-model="recurringTransactionItem.amount" label="*Amount"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-center layout px-0">
          <v-btn color="primary" round @click="editTransactionModal=false, recurringTransactionItem={}">Cancel</v-btn>
          <v-btn color="primary" round @click="saveRecurringTransaction">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "@/services/Api";
import LocationNetworks from "@/components/LocationNetworks.vue";
import Transactions from "@/components/Transactions.vue";
import DocumentUpload from '@/components/Documents.vue';

export default {
  props: ["locationnodesummary"],
  components: {
    locationnetworks: LocationNetworks,
    transactions: Transactions,
    documentcomponent: DocumentUpload
  },
  data() {
    return {
      locationNetworks: [],
      editTransactionModal: false,
      addTransactionModal: false,
      recurringTransactions: [],
      recurringTransactionItem: {},
      Partners: [{ id: 1, name: "Fibre Geeks" }],
      nodeDevices: [],
      customers: [],
      fibreFarmers: [],
      locationNodeDocuments:[],
      allFibreFarmers: [],
      salesValue: "",
      cosValue: "",
      expenseValue: "",
      loanValue: "",
      totals: [],
      nodeTransactions: [],
      locationNodeInfo: [],
      descriptionList:[],
      nodeTransactions:[],
      activeTabName:'',
      transactionTypes: ["Sales", "Cost of Sales", "Expense", "Loan"],
      salesTransactionCategories: [
        "Router Installation",
        "Data Activation Fee",
        "Internet Package",
        "Layer 2",
        "Layer 3",
        "SLA"
      ],
      cosTransactionCategories: ["Labour", "Network Management Fee", "Layer 2", "Layer 3"],
      expenseTransactionCategories: ["Hardware", "Labour", "Other"],
      loanTransactionCategories: [
        "Active Equipment",
        "Passive Equipment",
        "Civils",
        "Other"
      ],
      tabs: [
        { name: "networks", displayName: "Networks" },
        { name: "recurringTransactions", displayName: "Recurring Transactions" },
        { name: "transactions", displayName: "Transactions" },
        { name: "documents", displayName: "Documents" }
      ],
      headers: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        },
        {
          text: "Xero Code",
          align: "center",
          value: "xeroCode"
        },
        {
          text: "Transaction Type",
          align: "center",
          value: "transactionType"
        },
        {
          text: "Customer/Supplier",
          align: "center",
          value: "customerOrganisation.name"
        },
        {
          text: "Amount",
          align: "center",
          value: "amount"
        }
      ]
    };
  },

  created() {
    this.initialize();
  },
  async mounted() {
      this.setActiveTabName('networks')
  },

  methods: {
    saveNewRecurringTransaction(){
      Api()
      .post('/locationNodeRecurringTransactions',{
        locationNodeId: this.$route.params.locationNodeId,
        description: this.recurringTransactionItem.description,
        transactionType: this.recurringTransactionItem.transactionType,
        amount: this.recurringTransactionItem.amount,
        xeroCode: this.recurringTransactionItem.xeroCode,
        description: this.recurringTransactionItem.description,
        supplierOrganisationId: this.recurringTransactionItem.supplierOrganisationId,
        customerOrganisationId: this.recurringTransactionItem.customerOrganisationId,
        isActive: true,
        isDeleted: false
      }).then(this.getRecurringTransactions(), this.recurringTransactionItem={}, this.addTransactionModal=false)
    },
    saveRecurringTransaction(){
      Api()
      .put('/locationNodeRecurringTransactions/'+this.recurringTransactionItem.id,{
        description: this.recurringTransactionItem.description,
        transactionType: this.recurringTransactionItem.transactionType,
        amount: this.recurringTransactionItem.amount,
        xeroCode: this.recurringTransactionItem.xeroCode,
        description: this.recurringTransactionItem.description,
        supplierOrganisationId: this.recurringTransactionItem.supplierOrganisationId,
        customerOrganisationId: this.recurringTransactionItem.customerOrganisationId,
        isActive: true,
        isDeleted: false
      }).then(this.getRecurringTransactions(), this.recurringTransactionItem={},this.editTransactionModal=false)
    },
    addRecurringItem (item){
      if(this.authCreate(this.$store.state.currentRoute)){
        this.recurringTransactionItem = Object.assign({}, item);
        this.addTransactionModal=true
      }
    },
    editRecurringItem (item){
      if(this.authUpdate(this.$store.state.currentRoute)){
        this.recurringTransactionItem = Object.assign({}, item);
        this.editTransactionModal=true
      }
    },
    deleteRecurringItem (item){
      if(this.authDelete(this.$store.state.currentRoute)){
        this.recurringTransactionItem = Object.assign({}, item);
        confirm('Are you sure you want to delete this recurring transaction?')&&
        Api()
        .put('/locationNodeRecurringTransactions/'+item.id,{
          isActive: false,
          isDeleted: true
        }).then(response=>{
          let index = this.recurringTransactions.indexOf(item)
          this.recurringTransactions.splice(index, 1)
        })
      }
    },
    getRecurringTransactions() {
      Api()
        .get("/locationNodeRecurringTransactions/byNode/" + this.$route.params.locationNodeId)
        .then(response => {
          this.recurringTransactions = response.data;
        });
    },
    fetchDocuments(){
      Api()
      .get('/upload/byNode/'+this.$route.params.locationNodeId)
      .then(response=>{
        this.locationNodeDocuments=response.data
      })
    },
    getTransactions() {
      this.descriptionList = [];
      Api()
        .get("/transactions/byNode/" + this.$route.params.locationNodeId)
        .then(response => {
          this.nodeTransactions = response.data;
          for (let i = 0; i < this.nodeTransactions.length; i++) {
            if (
              !this.descriptionList.includes(
                this.nodeTransactions[i].description
              )
            ) {
              this.descriptionList.push(this.nodeTransactions[i].description);
            }
          }

          this.sum();
        });
    },
    getNodeDevices() {
      Api()
        .get("/devices/nodeLevelDevices/" + this.$route.params.locationNodeId)
        .then(response => {
          this.nodeDevices = response.data;
        });
    },
    getNodeInfo() {
      Api()
        .get("/locationNodes/" + this.$route.params.locationNodeId)
        .then(response => {
          this.locationNodeInfo = response.data[0];
        });
    },
    fetchCustomers(){
      Api()
        .get("/organisation/subOrganisations/all")
        .then(response => {
          this.customers = response.data;
        });  
    },

    fetchLocationNetworks() {
      Api()
        .get("/locationnetworks/byNode/" + this.$route.params.locationNodeId)
        .then(response => {
          this.locationNetworks = response.data;
        });
    },

    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    sum() {
      this.totals = [];
      this.salesValue = 0;
      this.cosValue = 0;
      this.expenseValue = 0;
      this.loanValue = 0;
      var res = {};

      this.nodeTransactions.forEach(function(el) {
        res[el.transactionType] = res[el.transactionType]
          ? (res[el.transactionType] += +el.amount)
          : +el.amount;
      });
      // for (let i=0; i< res.length;i++){

      // }
      this.totals.push(
        Object.keys(res).map(function(el) {
          return { transactionType: el, amount: res[el] };
        })
      );
      for (let i = 0; i < this.totals[0].length; i++) {
        if (this.totals[0][i].transactionType === "Sales") {
          this.salesValue = this.totals[0][i].amount;
        }
        if (this.totals[0][i].transactionType === "Cost of Sales") {
          this.cosValue = this.totals[0][i].amount;
        }
        if (this.totals[0][i].transactionType === "Expense") {
          this.expenseValue = this.totals[0][i].amount;
        }
        if (this.totals[0][i].transactionType === "Loan") {
          this.loanValue = this.totals[0][i].amount;
        }
      }
    },

    initialize() {
      this.fetchLocationNetworks();
      this.getTransactions();
      this.fetchDocuments();
      this.getNodeInfo();
      this.fetchCustomers();
      this.getRecurringTransactions();
    },
    editItem(item) {
      this.editedIndex = this.locationNetworks.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.locationNetworks.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.locationNetworks.splice(index, 1);
      Api().delete("/locationnetworks/" + this.editedItem.id);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.locationNetworkInfo.tvOverFibre === false) {
        this.locationNetworkInfo.gtuIncluded = false;
      }
      if (this.locationNetworkInfo.lineRentalIncluded === false) {
        this.locationNetworkInfo.residentialLineRentalValue = 0;
      }
      Api().put("/locationnetworks/" + this.locationNetworkInfo.id, {
        name: this.locationNetworkInfo.name,
        locationNodeId: this.locationNetworkInfo.locationNodeId,
        lineRentalIncluded: this.locationNetworkInfo.lineRentalIncluded,
        tvOverFibre: this.locationNetworkInfo.tvOverFibre,
        gtuIncluded: this.locationNetworkInfo.gtuIncluded,
        activationFee: this.locationNetworkInfo.activationFee,
        routerInstallationFee: this.locationNetworkInfo.routerInstallationFee,
        residentialLineRentalValue: this.locationNetworkInfo.residentialLineRentalValue,
        isDeleted: false,
        isActive: this.locationNetworkInfo.isActive
      });
      this.$emit("successfullySaved");

      this.locationNetworks.push(this.editedItem);
    }
  }
};
</script>
<style>
.Planned {
  border-left: solid #d61212;
}
.Ongoing {
  border-left: 4px solid #eb780c;
}
.Complete {
  border-left: 4px solid #5eb110;
}
.Live {
  border-left: 4px solid #5eb110;
}
</style>
